
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Transpiler for older browsers
import 'core-js/stable';
// optional but required for transforming generator fns.
import 'regenerator-runtime/runtime';

import '../../sass/frontend/app.scss';
import '../bootstrap';
import '../plugins';
import Vue from 'vue';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faUser, faUserCircle, faShoppingCart, faHeart, faCheck, faChevronRight, faChevronLeft,
  faThLarge, faThList, faTrashAlt, faListAlt, faSignOut, faCommentAltDollar, faLockAlt, faEdit,
  faTrash, faList, faTruck, faQuestionCircle, faBox, faUndo, faBars, faCircleNotch, faTimesCircle,
  faCheckDouble, faCheckCircle, faSearch, faTimes, faExclamationCircle, faAngleDown, faPlus,
  faFileSpreadsheet, faSortAmountDownAlt, faSortAmountDown, faFilter
} from '@fortawesome/pro-regular-svg-icons';
import {
  faSignIn, faUserPlus,
} from '@fortawesome/pro-light-svg-icons';
import {
  faHeart as faSolidHeart, faPhone, faFilePdf
} from '@fortawesome/pro-solid-svg-icons';
import { faLine, faFacebookSquare } from '@fortawesome/free-brands-svg-icons';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueWait from 'vue-wait';
import Notifications from 'vue-notification';
import VueMeta from 'vue-meta';
import VModal from 'vue-js-modal';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BootstrapVue from 'bootstrap-vue';
import VueSocialauth from 'vue-social-auth';
import i18n from '../locales';
import routes from './routes';
import translations from '../translations'; // eslint-disable-line no-unused-vars


/**
 * Font Awesome
 *
 * Is recommended import just the icons that you use, for decrease considerably the file size.
 * You can see at next link, how it works: https://github.com/FortAwesome/Font-Awesome/blob/master/UPGRADING.md#no-more-default-imports
 * Also you can import the icons separately on the frontend and backend
 */

/**
 * Vuex State Management
 * https://vuex.vuejs.org
 */
import store from './store';

/**
 * Vue Filters
 */
import '../vue-common-filters';
import './filters';

Vue.use(BootstrapVue);


window.Vue = Vue;

library.add(
  faPhone, faLine, faUser, faUserCircle, faShoppingCart, faFacebookSquare, faHeart, faCheck,
  faChevronRight, faChevronLeft, faThLarge, faThList, faSignIn, faUserPlus, faTrashAlt,
  faCheckCircle, faListAlt, faSignOut, faCommentAltDollar, faLockAlt, faEdit, faTrash,
  faList, faTruck, faQuestionCircle, faBox, faUndo, faBars, faCircleNotch, faTimesCircle,
  faCheckDouble, faCheckCircle, faSolidHeart, faSearch, faTimes, faExclamationCircle,
  faAngleDown, faPlus, faFileSpreadsheet, faFilePdf, faSortAmountDown, faSortAmountDownAlt,
  faFilter
);
// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch();

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCWjqbJoG5LYu0kGA2UiYFYFzgjuWX0rf4',
  },
});
Vue.use(VueWait);
Vue.use(Notifications);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('responsive-menu', require('./components/layouts/ResponsiveMenu.vue').default);
Vue.component('footer-component', require('./components/layouts/Footer.vue').default);
Vue.component('product-responsive-filters', require('./components/product/ProductResponsiveFilters.vue').default);

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('elementor', require('./components/ElementorComponent.vue').default);

Vue.component('navigation', require('./components/layouts/Navigation.vue').default);
Vue.component('breadcrumbs', require('./components/layouts/Breadcrumbs.vue').default);
Vue.component('compare-bar', require('./components/compare/CompareBar.vue').default);

/**
 * Authentication Components
 */
Vue.component('login', require('./components/auth/Login.vue').default);
Vue.component('register', require('./components/auth/Register.vue').default);

/**
 * Passport Components
 */
Vue.component('passport-clients', require('./components/passport/Clients.vue').default);
Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients.vue').default);
Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens.vue').default);

Vue.component('font-awesome-icon', FontAwesomeIcon);

/**
 * Vue Translation Plugin
 */
console.log('checking store', store.getters['auth/user']);
const currentLocale = store.getters['auth/user'].locale || 'th';
Vue.use(i18n, {
  locale: currentLocale,
  fallback: 'en',
});

window.moment.locale(currentLocale);

Vue.use(VModal, { dialog: true });

Vue.prototype.$http = axios;
Vue.use(VueSocialauth, {
  providers: {
    facebook: {
      clientId: window.spaConfig.facebook.clientId,
      redirectUri: window.spaConfig.facebook.redirectUrl,
    },
  },
});

const app = new Vue({ // eslint-disable-line no-unused-vars
  el: '#app',
  store,
  router: routes,
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: false,
    // all titles will be injected into this template
    titleTemplate: '%s | Spark Intertrade',
  },
  wait: new VueWait({
    // Defaults values are following:
    useVuex: true, // Uses Vuex to manage wait state
    vuexModuleName: 'wait', // Vuex module name
    registerComponent: true, // Registers `v-wait` component
    componentName: 'v-wait', // <v-wait> component name, you can set `my-loader` etc.
    registerDirective: true, // Registers `v-wait` directive
    directiveName: 'wait', // <span v-wait /> directive name, you can set `my-loader` etc.
  }),
});
